import React from "react";
import { cn } from "@/lib/utils";
import elokon from "../../images/brands/elokon.svg";
import bayer from "../../images/brands/bayer.svg";
import bmw from "../../images/brands/bmw.svg";
import denso from "../../images/brands/denso.svg";
import jabil from "../../images/brands/jabil.svg";
import mercedesBenz from "../../images/brands/mercedes-benz.svg";
import loreal from "../../images/brands/loreal.png";
import nestle from "../../images/brands/nestle.svg";
import siemens from "../../images/brands/siemens.svg";
import { store } from "../../store";
import { observer } from "mobx-react";

interface Brand {
    name: string;
    url: string;
    wide: boolean;
}

const BRANDS: Brand[] = [
    { url: bmw, name: "BMW", wide: false },
    { url: denso, name: "Denso", wide: true },
    { url: bayer, name: "Bayer", wide: false },
    { url: jabil, name: "Jabil", wide: true },
    { url: mercedesBenz, name: "Mercedes-Benz", wide: false },
    { url: loreal, name: "L’Oréal", wide: true },
    { url: siemens, name: "Siemens", wide: true },
    { url: nestle, name: "Nestle", wide: false },
];

export const Brands = observer((): JSX.Element => {
    const t = store.i18n.t;

    return (
        <div className="flex flex-col gap-4 pb-8 sm:gap-6">
            <div className="flex w-full items-center justify-center gap-2">
                <img src={elokon} alt="ELOKON" className="h-4 w-auto" />
                <span className="text-xs font-medium uppercase">{t("brands.trustedBy")}</span>
            </div>
            <div className="flex flex-wrap items-center justify-center gap-4 px-2 lg:gap-8">
                {BRANDS.map((brand) => (
                    <img
                        key={brand.name}
                        alt={brand.name}
                        src={brand.url}
                        className={cn("h-8.5 w-auto", brand.wide && "h-5")}
                    />
                ))}
            </div>
        </div>
    );
});
